"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bpmSteps2NumberId = exports.bpmSteps2 = void 0;
/* eslint-disable no-template-curly-in-string */
var bpmSteps2 = {
    "8e8735f8-60a8-11eb-b6f6-9e5278390029": [
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "StartLiveRadiologyProcess",
                    type: "conditionalStartEvent",
                    name: "Start radiology process",
                    subprocessName: null
                },
                iteration: 0,
                createdDate: "2021-03-16T11:24:01.444-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:24:01.400-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:24:01.400-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveStartLiveRadiologyProcess",
                            name: null,
                            destinationId: "RetrieveCaseConfigurationServiceTask",
                            condition: "${caseEvent.equals(true)}"
                        },
                        iterations: "0"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "RetrieveCaseConfigurationServiceTask",
                    type: "serviceTask",
                    name: "Retrieve case configuration",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:24:01.494-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:24:01.477-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:24:02.375-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveRetrieveCaseConfigurationServiceTask",
                            name: null,
                            destinationId: "UpdateCaseStatusToInProgressServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "UpdateCaseStatusToInProgressServiceTask",
                    type: "serviceTask",
                    name: "Update case status to 'In Progress'",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:24:02.414-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:24:02.413-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:24:02.616-0400[America/New_York]",
                inputs: [
                    {
                        key: "status",
                        value: "In Progress"
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveUpdateCaseStatusToInProgress",
                            name: null,
                            destinationId: "UpdateProcessInstanceStatusToStartedServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "UpdateProcessInstanceStatusToStartedServiceTask",
                    type: "serviceTask",
                    name: "Update process Instance status to 'Process Created'",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:24:02.646-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:24:02.645-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:24:02.966-0400[America/New_York]",
                inputs: [
                    {
                        key: "status",
                        value: "Process Created"
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveUpdateProcessInstanceStatusToStartedServiceTask",
                            name: "",
                            destinationId: "CheckProcessInstanceRequiredFieldsServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "CheckProcessInstanceRequiredFieldsServiceTask",
                    type: "serviceTask",
                    name: "Check process instance required fields",
                    subprocessName: null
                },
                iteration: 2,
                createdDate: "2021-03-16T11:24:02.996-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:21.152-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:21.330-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveCheckProcessInstanceRequiredFieldsServiceTask",
                            name: "",
                            destinationId: "IsAllRequiredProcessInstanceDataAvailableExclusiveGateway",
                            condition: null
                        },
                        iterations: "1,2"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "IsAllRequiredProcessInstanceDataAvailableExclusiveGateway",
                    type: "exclusiveGateway",
                    name: "Is all required process instance data available?",
                    subprocessName: null
                },
                iteration: 2,
                createdDate: "2021-03-16T11:24:03.106-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:21.354-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:21.370-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "AllRequireProcessInstanceDataNotPresent",
                            name: "No",
                            destinationId: "RetrieveCaseNotesServiceTask",
                            condition: '${( (processInstanceRequiredFields.equals(false)) or ("MAPPING_SERVICE_NOT_AVAILABLE".equals(exam_code_mapping_result)) ) and processDataIterationCurrentCount < processDataTotalIterations}'
                        },
                        iterations: "1"
                    },
                    {
                        transitionDefinition: {
                            transitionId: "AllRequireProcessInstanceDataIsPresent",
                            name: "All data is present OR Wait time exceeded",
                            destinationId: "RetrieveProcessInstanceServiceTask",
                            condition: '${(processInstanceRequiredFields.equals(true) && (!"MAPPING_SERVICE_NOT_AVAILABLE".equals(exam_code_mapping_result))) || (processDataIterationCurrentCount >= processDataTotalIterations)}'
                        },
                        iterations: "2"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "RetrieveCaseNotesServiceTask",
                    type: "serviceTask",
                    name: "Retrieve notes",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:24:03.197-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:24:03.195-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:24:03.361-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveRetrieveNotes",
                            name: null,
                            destinationId: "CollectProcessInstanceDataServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "CollectProcessInstanceDataServiceTask",
                    type: "serviceTask",
                    name: "Collect process instance data",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:24:03.375-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:24:03.374-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:24:04.614-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveCollectProcessInstanceDataServiceTask",
                            name: "",
                            destinationId: "RetrieveAndSaveExamCodeMapServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "RetrieveAndSaveExamCodeMapServiceTask",
                    type: "serviceTask",
                    name: "Retrieve and save exam code map",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:24:04.654-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:24:04.653-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:24:05.666-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveRetrieveAndSaveExamCodeMap",
                            name: null,
                            destinationId: "RetrieveAndSaveClinicalArtifactServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "RetrieveAndSaveClinicalArtifactServiceTask",
                    type: "serviceTask",
                    name: "Retrieve and save clinical artifact",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:24:05.696-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:24:05.695-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:24:05.867-0400[America/New_York]",
                inputs: [
                    {
                        key: "codeSetType",
                        value: "clinical"
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveRetrieveAnSaveClinicalArtifact",
                            name: null,
                            destinationId: "UpdateProcessInstanceToWaitingForDataServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "UpdateProcessInstanceToWaitingForDataServiceTask",
                    type: "serviceTask",
                    name: "Update process instance to 'Waiting for Data'",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:24:05.900-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:24:05.899-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:24:05.953-0400[America/New_York]",
                inputs: [
                    {
                        key: "status",
                        value: "Waiting for Data"
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveUpdateProcessInstanceToWaitingForDataServiceTask",
                            name: "",
                            destinationId: "WaitForProcessInstanceDataTimerCatchEvent",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "WaitForProcessInstanceDataTimerCatchEvent",
                    type: "intermediateTimer",
                    name: "Wait for process instance data",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:24:05.973-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:24:05.972-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:21.072-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveWaitForProcessInstanceDataTimerCatchEvent",
                            name: "",
                            destinationId: "CheckProcessInstanceRequiredFieldsServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "RetrieveProcessInstanceServiceTask",
                    type: "serviceTask",
                    name: "Retrieve process instance",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:21.401-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:21.399-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:21.757-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveRetrieveProcessInstanceServiceTask",
                            name: null,
                            destinationId: "UpdateProcessInstanceToDataCollectedServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "UpdateProcessInstanceToDataCollectedServiceTask",
                    type: "serviceTask",
                    name: "Update process instance to 'Data Collected'",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:21.775-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:21.775-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:22.108-0400[America/New_York]",
                inputs: [
                    {
                        key: "status",
                        value: "Data Collected"
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveUpdateProcessInstanceToDataCollectedServiceTask",
                            name: "",
                            destinationId: "CaseRunImportMappingSubprocess",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "CaseRunImportMappingSubprocess",
                    type: "callActivity",
                    name: "Run case run import mapping",
                    subprocessName: "CaseRunImportMappingProcess"
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:22.121-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:22.120-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:23.070-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveCaseRunImportMappingSubprocess",
                            name: null,
                            destinationId: "PrePredictionDecoratorSubprocess",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "CaseRunImportMappingProcess",
                    activityId: "StartCaseRunImportMappingSubprocess",
                    type: "startEvent",
                    name: "Start import mapping",
                    subprocessName: null
                },
                iteration: 0,
                createdDate: "2021-03-16T11:26:22.253-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:22.249-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:22.249-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveStartCaseRunImportMappingSubprocess",
                            name: null,
                            destinationId: "CaseRunImportMappingBusinessTask",
                            condition: null
                        },
                        iterations: "0"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "CaseRunImportMappingProcess",
                    activityId: "CaseRunImportMappingBusinessTask",
                    type: "businessRuleTask",
                    name: "Run mappings",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:22.267-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:22.266-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:22.952-0400[America/New_York]",
                inputs: [
                    {
                        key: "decisionKeys",
                        value: '["import_mapping_rules","import_mapping_rules_phs","import_mapping_rules_mgh"]'
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveCaseRunImportMappingBusinessTask",
                            name: null,
                            destinationId: "EndCaseRunImportMappingSubprocess",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: [
                {
                    processId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                    executionTime: "2021-03-16T11:26:22.648-0400[America/New_York]",
                    decisionDefinitionDto: {
                        taskId: "CaseRunImportMappingBusinessTask",
                        decisionKey: "import_mapping_rules",
                        decisionName: "Import Mapping Rules",
                        hitPolicy: "COLLECT",
                        camundaVersion: 15,
                        decisionRules: []
                    },
                    decisionInputs: [],
                    decisionOutputs: []
                },
                {
                    processId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                    executionTime: "2021-03-16T11:26:22.766-0400[America/New_York]",
                    decisionDefinitionDto: {
                        taskId: "CaseRunImportMappingBusinessTask",
                        decisionKey: "import_mapping_rules_phs",
                        decisionName: "Import Mapping Rules PHS",
                        hitPolicy: "COLLECT",
                        camundaVersion: 15,
                        decisionRules: [
                            {
                                ruleId: "DecisionRule_1l8vxir",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1ay6w9q",
                                        condition: "${caseRun.getBillingProviderAssistantNumber() != null}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_167k5i0",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1r7du7e",
                                        condition: "${caseRun.getBillingProviderAssistantNumber() != null}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0t418mw",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0o3oamv",
                                        condition: "${caseRun.getBillingProviderAssistantNumber() == null}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0nbqiuu",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_13h39dc",
                                        condition: "${caseRun.getBillingProviderAssistantNumber() == null}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1pcrn82",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_09uwdio",
                                        condition: "${caseRun.getOrderingProviderNumber() != null}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_15rwajs",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1knkk4k",
                                        condition: "${caseRun.getOrderingProviderNumber() != null}"
                                    }
                                ]
                            }
                        ]
                    },
                    decisionInputs: [
                        {
                            source: "case_data",
                            key: "billing_provider_assistant_number",
                            value: "null"
                        },
                        {
                            source: "case_data",
                            key: "ordering_provider_number",
                            value: '{"number":"1785859","issuer":"EPIC","type":"EPIC"}'
                        }
                    ],
                    decisionOutputs: [
                        {
                            matchedDecisionRuleId: "DecisionRule_0t418mw",
                            mappedKey: "mapping_value",
                            mappedValue: "AVERY, LAURA"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_0t418mw",
                            mappedKey: "map_to_property",
                            mappedValue: "rendering_provider_name"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_0nbqiuu",
                            mappedKey: "mapping_value",
                            mappedValue: '{"number":"1005151","issuer":"EPIC","type":"EPIC"}'
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_0nbqiuu",
                            mappedKey: "map_to_property",
                            mappedValue: "rendering_provider_number"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1pcrn82",
                            mappedKey: "mapping_value",
                            mappedValue: "WHITEHEAD, DAVID"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1pcrn82",
                            mappedKey: "map_to_property",
                            mappedValue: "referring_provider_name"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_15rwajs",
                            mappedKey: "mapping_value",
                            mappedValue: '{"number":"1785859","issuer":"EPIC","type":"EPIC"}'
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_15rwajs",
                            mappedKey: "map_to_property",
                            mappedValue: "referring_provider_number"
                        }
                    ]
                }
            ]
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "PrePredictionDecoratorSubprocess",
                    type: "callActivity",
                    name: "Run pre-prediction decorator",
                    subprocessName: "PrePredictionCategorizeProcess"
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:23.100-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:23.099-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:25.659-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeavePrePredictionDecoratorSubprocess",
                            name: null,
                            destinationId: "PrePredictionRulesSubprocess",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "PrePredictionCategorizeProcess",
                    activityId: "StartPrePredictionDecorationSubprocess",
                    type: "startEvent",
                    name: "Start decoration",
                    subprocessName: null
                },
                iteration: 0,
                createdDate: "2021-03-16T11:26:23.207-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:23.204-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:23.204-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveStartPrePredictionDecorationRulesSubprocess",
                            name: null,
                            destinationId: "PrePredictionSystemDecorationBusinessTask",
                            condition: null
                        },
                        iterations: "0"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "PrePredictionCategorizeProcess",
                    activityId: "PrePredictionSystemDecorationBusinessTask",
                    type: "businessRuleTask",
                    name: "Run system decoration",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:23.217-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:23.216-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:24.674-0400[America/New_York]",
                inputs: [
                    {
                        key: "decisionKeys",
                        value: '["pre_prediction_decoration"]'
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeavePrePredictionSystemDecorationBusinessTask",
                            name: null,
                            destinationId: "PrePredictionHealthSystemDecorationBusinessTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: [
                {
                    processId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                    executionTime: "2021-03-16T11:26:24.527-0400[America/New_York]",
                    decisionDefinitionDto: {
                        taskId: "PrePredictionSystemDecorationBusinessTask",
                        decisionKey: "pre_prediction_decoration",
                        decisionName: "Pre-Prediction Decoration",
                        hitPolicy: "COLLECT",
                        camundaVersion: 15,
                        decisionRules: [
                            {
                                ruleId: "DecisionRule_03bbvfy",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1o4zeah",
                                        condition: '${cmx:compareISODates(caseRun.getDateOfService(),caseConfigJson.get("go_live_date"),"<")}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0m4tswv",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1e90dy8",
                                        condition: '${cmx:compareISODates(caseRun.getDateOfService(),caseConfigJson.get("end_date"),">=")}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1vltvj5",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1j6lve1",
                                        condition: '${cmx:compareISODates(caseRun.getDateOfService(),dateTime().minusDays(caseConfigJson.get("max_age_in_days")).toString("yyyyMMdd"),"<")}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0rc5509",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_09i6kdf",
                                        condition: '${cmx:isInList(caseRun.getPointOfCare(),caseConfigJson.get("point_of_care_exclusions"),true)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0vg3awg",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0lpuabp",
                                        condition: '${cmx:isInTenantOrHealthSystemPropertyGroup("Radiology Excluded Providers",caseRun.getTenantCode(),caseRun.getHealthSystemCode(),caseRun.getDateOfService(),false,cmx:nvp("Provider Name","*"),cmx:nvp("Provider Id",cmx:getProperty(caseRun.getBillingProviderNumber(),"getNumber()")))}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1i4qdxy",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1byk59q",
                                        condition: '${cmx:isInTenantDictionary("Excluded Exam Codes",caseRun.getTenantCode(),caseRun.getDateOfService(),caseRun.getExamCode(),true)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0d01s91",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1c98lu0",
                                        condition: '${cmx:isInList(caseRun.getExamDescription(),caseConfigJson.get("exam_description_exclusions"),true)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1r6ckq7",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1dihu2q",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(caseRun.getResultStatus(),"P")}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0xz0mnc",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_06ro6sx",
                                        condition: "${false}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_01eidcr",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_06y9b8p",
                                        condition: "${cmx:isStringEmpty(caseRun.getPatientGender())}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0wb89bx",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1t06vut",
                                        condition: "${cmx:isStringEmpty(caseRun.getDateOfBirth())}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0qm1f30",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0gxcc8u",
                                        condition: "${cmx:isStringEmpty(caseRun.getDateOfService())}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_10lj6yc",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1vjig8f",
                                        condition: "${cmx:isStringEmpty(caseRun.getExamCode())}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1hff0zu",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1v1cidi",
                                        condition: "${cmx:isStringEmpty(caseRun.getTenantCode())}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_174fl3j",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1aytkhx",
                                        condition: "${cmx:isStringEmpty(caseRun.getServiceLine())}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0d6i7pg",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_11654x5",
                                        condition: "${cmx:isNoteEmpty(caseRun.getNotes())}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_17ag6no",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1s0y1e3",
                                        condition: '${cmx:isInList(caseRun.getSchedulingDepartment(), caseConfigJson.get("scheduling_department_exclusions"), true)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0z02n8s",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1a06993",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(exam_code_mapping_result, "NO_MAPPING")}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0kkdn4e",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_08m5qok",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(exam_code_mapping_result, "NO_CPT_MAPPING")}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_142q3f9",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0ouaf2s",
                                        condition: '${cmx:isStringEmpty(cmx:getProperty(caseRun.getBillingProviderNumber(),"getNumber()"))}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1oucppy",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1j76pee",
                                        condition: '${cmx:compareISODates(caseRun.getDateOfService(),"2020-10-01","<")}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_06q2zpm",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1jj5dc4",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(previousProcessInstanceStatus,"Manual")}'
                                    }
                                ]
                            }
                        ]
                    },
                    decisionInputs: [
                        {
                            source: "case_data",
                            key: "date_of_service",
                            value: "2020-04-23"
                        },
                        {
                            source: "case_data",
                            key: "point_of_care",
                            value: "MGH_MGH EMER"
                        },
                        {
                            source: "case_data",
                            key: "tenant_code",
                            value: "MGH"
                        },
                        {
                            source: "case_data",
                            key: "health_system_code",
                            value: "PHS"
                        },
                        {
                            source: "case_data",
                            key: "billing_provider_number",
                            value: '{"number":"1005151","issuer":"EPIC","type":"EPIC"}'
                        },
                        {
                            source: "case_data",
                            key: "exam_code",
                            value: "CT.VA.ABDPELAG@"
                        },
                        {
                            source: "case_data",
                            key: "exam_description",
                            value: "CT ANGIO ABDOMEN/PELVIS WITH AND WITHOUT CONTRAST"
                        },
                        {
                            source: "case_data",
                            key: "result_status",
                            value: "F"
                        },
                        {
                            source: "case_data",
                            key: "patient_gender",
                            value: "M"
                        },
                        {
                            source: "case_data",
                            key: "date_of_birth",
                            value: "1952-04-26"
                        },
                        {
                            source: "case_data",
                            key: "service_line",
                            value: "Radiology"
                        },
                        {
                            source: "case_data",
                            key: "notes",
                            value: '[{"document_id":176,"description":null,"content":"CT ANGIO ABDOMEN/PELVIS WITH AND WITHOUT CONTRAST  ABDOMINOPELVIC CTA WITH AND WITHOUT IV CONTRAST.     TECHNIQUE: Helically acquired axial images from the dome of the diaphragm to the femoral area were obtained without oral or IV contrast, followed by helically acquired axial images from the  diaphragm to the femoral area during the dynamic IV injection of contrast. 2 min delayed images were obtained from the same area.    3D IMAGES WITH REFORMATTING AND POST-PROCESSING RECONSTRUCTIONS WERE PERFORMED AND INTERPRETED.  COMPARISON: CT ANGIO ABDOMEN/PELVIS WITH AND WITHOUT CONTRAST 2016-Dec-19  FINDINGS:   VASCULAR:  The patient is status post infrarenal abdominal aortic endograft placement, with the proximal attachment at the suprarenal level, and distal  within the left common iliac artery.  No endoleaks are detected. When compared to prior exam there is no signs of stent migration  Again noted is occlusion of the right common iliac artery, with distal reconstitution at the level of the bifurcation. Redemonstration the right arterial presacral collaterals. Again seen are extensive atherosclerotic calcifications in the right external and internal iliac arteries, with scattered areas of stenosis.  There are moderate calcified and noncalcified atherosclerotic plaques in the aorta and its major branches.  There is no evidence of a flap within the aorta to suggest a dissection.  The celiac artery and SMA are patent. The IMA is excluded. There are single renal artery bilaterally. They are widely patent without signs of significant stenosis.    The aortoiliac system is patent without significant stenosis. There is no vein thrombosis.   NON VASCULAR: LOWER THORAX: There is diffuse bronchial wall thickening with areas of mucosal plugging and scattered groundglass opacities the right middle and lower lobes, suggestive of aspiration. There is a moderate-sized hiatal hernia.  HEPATOBILIARY: No focal hepatic lesions.  No biliary ductal dilatation. SPLEEN: No splenomegaly. PANCREAS: No focal masses or ductal dilatation.  ADRENALS: No adrenal nodules. KIDNEYS/URETERS: No hydronephrosis, stones, or solid mass lesions. Again seen are unchanged scattered hypodensities throughout the kidneys, too small to characterize. PELVIC ORGANS/BLADDER: There is diffuse bladder wall thickening and pericystic fat stranding.  PERITONEUM / RETROPERITONEUM: No free air or fluid. LYMPH NODES: No lymphadenopathy.  GI TRACT: No distention or wall thickening. The appendix is unremarkable.  BONES AND SOFT TISSUES: There are postoperative changes from left total hip arthroplasty and fixation of the right femur. There are multiple healed fractures in bilateral lower ribs. There are discogenic degenerative changes, most prominently seen at L1-2 disc space. There is a right small fat-containing inguinal hernia.  IMPRESSION: Status post abdominal aorta endograft, stable since 2016.  CT findings suggestive of acute cystitis.  Diffuse bronchial wall thickening with areas of mucosal plugging and scattered groundglass opacities the right middle and lower lobes, suggestive of aspiration.  ATTESTATION: I, Dr. Laura L. Avery, MD as teaching physician, have reviewed the images for this case and if necessary edited the report originally created by Dr. Maria Gabriela Figueiro Longo.   Interpreted by: Laura Louise Avery, MD Maria Gabriela Figueiro Longo, MD  Signed by: Laura Louise Avery, MD 4/23/20  CC Recipients: David A Peak, MD - In Basket (authorizing provider)  Final result","filename":null,"type":"RAW","id":null}]'
                        },
                        {
                            source: "case_data",
                            key: "scheduling_department",
                            value: "null"
                        },
                        {
                            source: "config_data",
                            key: "go_live_date",
                            value: "2020-01-01"
                        },
                        {
                            source: "config_data",
                            key: "end_date",
                            value: "2999-12-31"
                        },
                        {
                            source: "config_data",
                            key: "max_age_in_days",
                            value: "180"
                        },
                        {
                            source: "config_data",
                            key: "point_of_care_exclusions",
                            value: '["SHC_HOPEBDSD"]'
                        },
                        {
                            source: "config_data",
                            key: "exam_description_exclusions",
                            value: '["exclude"]'
                        },
                        {
                            source: "config_data",
                            key: "scheduling_department_exclusions",
                            value: '["BWH VASCULAR","BWF ECHOCARDIO CLIN","BWH VASCULAR FXB","BWF VASCULAR LAB","BWP CV VASC US WEY"]'
                        },
                        {
                            source: "process_var_data",
                            key: "exam_code_mapping_result",
                            value: "MAPPING_SUCCESS"
                        },
                        {
                            source: "process_var_data",
                            key: "previousProcessInstanceStatus",
                            value: "null"
                        }
                    ],
                    decisionOutputs: [
                        {
                            matchedDecisionRuleId: "DecisionRule_1vltvj5",
                            mappedKey: "decoration_category",
                            mappedValue: "Invalid Case"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1vltvj5",
                            mappedKey: "decoration_subcategory",
                            mappedValue: "Date of Service"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1vltvj5",
                            mappedKey: "decoration_description",
                            mappedValue: "DOS older than configured age"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1oucppy",
                            mappedKey: "decoration_category",
                            mappedValue: "Invalid Case"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1oucppy",
                            mappedKey: "decoration_subcategory",
                            mappedValue: "Date of Service Invalid for Prediction"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1oucppy",
                            mappedKey: "decoration_description",
                            mappedValue: "Invalid DOS for Code Prediction"
                        }
                    ]
                }
            ]
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "PrePredictionCategorizeProcess",
                    activityId: "PrePredictionHealthSystemDecorationBusinessTask",
                    type: "businessRuleTask",
                    name: "Run health system decoration",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:24.705-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:24.703-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:25.317-0400[America/New_York]",
                inputs: [
                    {
                        key: "decisionKeys",
                        value: '["pre_prediction_decoration_phs"]'
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeavePrePredictionHealthSystemDecorationBusinessTask",
                            name: null,
                            destinationId: "PrePredictionTenantDecorationBusinessTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: [
                {
                    processId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                    executionTime: "2021-03-16T11:26:25.214-0400[America/New_York]",
                    decisionDefinitionDto: {
                        taskId: "PrePredictionHealthSystemDecorationBusinessTask",
                        decisionKey: "pre_prediction_decoration_phs",
                        decisionName: "Pre-Prediction Decoration PHS",
                        hitPolicy: "COLLECT",
                        camundaVersion: 15,
                        decisionRules: [
                            {
                                ruleId: "DecisionRule_0zl4tsd",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1cm6xdr",
                                        condition: '${cmx:doesStringStartWithValueIgnoreCase(cmx:getProperty(caseRun.getPrimaryClinicalIdentifier(),"getNumber()"), "L")\n&& cmx:doesAnyNoteContainValue(caseRun.getNotes(),null,null,"examination can not be read because",true,true)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_04oxfh1",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_04q7678",
                                        condition: '${cmx:doesStringStartWithValueIgnoreCase(cmx:getProperty(caseRun.getPrimaryClinicalIdentifier(),"getNumber()"), "L") \n&& cmx:doesAnyNoteContainValue(caseRun.getNotes(),null,null,"examination can not be interpreted because",true,true)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_16qx9qa",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_11hrb3w",
                                        condition: '${cmx:doesStringStartWithValueIgnoreCase(cmx:getProperty(caseRun.getPrimaryClinicalIdentifier(),"getNumber()"), "L") \n&& cmx:doesAnyNoteContainValue(caseRun.getNotes(),null,null,"examination was not interpreted because",true,true)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1ok08u2",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1lisj2r",
                                        condition: '${cmx:doesStringMatchRegex(caseRun.getExamDescription(),".*(NO INTERPRETATION).*")}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0b0rfzm",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_06703sv",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(caseRun.getResultStatus(),"C") && (exam_code_changed == null)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0bqgk90",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0muzox9",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(caseRun.getResultStatus(),"C") && (exam_code_changed != null && exam_code_changed == false) && cmx:doesStringEqualValueIgnoreCase(previousProcessInstanceStatus,"Manual")}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_02bmy0r",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1mfrjfa",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(caseRun.getResultStatus(),"C") && (exam_code_changed != null && exam_code_changed == false) && (!cmx:doesStringEqualValueIgnoreCase(previousProcessInstanceStatus,"Manual"))}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0541kub",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1idskia",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(caseRun.getResultStatus(),"C") && (exam_code_changed != null && exam_code_changed == true)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0i8niuo",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_04dwlu7",
                                        condition: "${cmx:isStringEmpty(caseRun.getExamCode())}"
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_145gqwz",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0c0otb4",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(caseRun.getSchedulingDepartment(), "HOPE IMG BDSIDE US")}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_09zzvyt",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1hqyx9l",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(caseRun.getResourceName(), "NSM HYOR1") && cmx:isStringEmpty(cmx:getProperty(caseRun.getBillingProviderNumber(),"getNumber()"))}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_048gs4x",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0duop2i",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(caseRun.getResourceName(), "NSM HYOR1") && cmx:isStringNotEmpty(cmx:getProperty(caseRun.getBillingProviderNumber(),"getNumber()"))}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1q8lvuk",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_11klzrq",
                                        condition: '${cmx:isInTenantOrHealthSystemPropertyGroup("Provider Resource Suppress Claim",caseRun.getTenantCode(),caseRun.getHealthSystemCode(),caseRun.getDateOfService(),true,cmx:nvp("Resource",caseRun.getResourceName()),cmx:nvp("Provider Number",cmx:getProperty(caseRun.getBillingProviderNumber(),"getNumber()")),cmx:nvp("Entities",caseRun.getTenantCode()))}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0xz0mnc",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_06ro6sx",
                                        condition: '${cmx:doesAnyNoteContainAnyValue(caseRun.getNotes(),null,"SIGNED BY:",cmx:getTenantDictionaryValues("Aborted Phrases",caseRun.getTenantCode(),caseRun.getDateOfService()),true,true)\n&& !cmx:doesAnyNoteContainAnyValue(caseRun.getNotes(),null,"SIGNED BY:",cmx:getValuesFromTenantOrHealthSystemPropertyGroup("Aborted Phrase Exceptions",caseRun.getTenantCode(),caseRun.getHealthSystemCode(),caseRun.getDateOfService(),"Phrase",true,cmx:nvp("Exam Code",caseRun.getExamCode()),cmx:nvp("Provider Number",cmx:getProperty(caseRun.getBillingProviderNumber(),"getNumber()")),cmx:nvp("Phrase","*")),true,true)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_18mszc1",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1132uy0",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(caseRun.getResultStatus(),"F") \n&& (cmx:doesStringEqualValueIgnoreCase(previousProcessInstanceStatus,"Automated"))}'
                                    }
                                ]
                            }
                        ]
                    },
                    decisionInputs: [
                        {
                            source: "case_data",
                            key: "primary_clinical_identifier",
                            value: '{"number":"E15606771","issuer":"EPC","type":"ACCESSION_NUMBER"}'
                        },
                        {
                            source: "case_data",
                            key: "notes",
                            value: '[{"document_id":176,"description":null,"content":"CT ANGIO ABDOMEN/PELVIS WITH AND WITHOUT CONTRAST  ABDOMINOPELVIC CTA WITH AND WITHOUT IV CONTRAST.     TECHNIQUE: Helically acquired axial images from the dome of the diaphragm to the femoral area were obtained without oral or IV contrast, followed by helically acquired axial images from the  diaphragm to the femoral area during the dynamic IV injection of contrast. 2 min delayed images were obtained from the same area.    3D IMAGES WITH REFORMATTING AND POST-PROCESSING RECONSTRUCTIONS WERE PERFORMED AND INTERPRETED.  COMPARISON: CT ANGIO ABDOMEN/PELVIS WITH AND WITHOUT CONTRAST 2016-Dec-19  FINDINGS:   VASCULAR:  The patient is status post infrarenal abdominal aortic endograft placement, with the proximal attachment at the suprarenal level, and distal  within the left common iliac artery.  No endoleaks are detected. When compared to prior exam there is no signs of stent migration  Again noted is occlusion of the right common iliac artery, with distal reconstitution at the level of the bifurcation. Redemonstration the right arterial presacral collaterals. Again seen are extensive atherosclerotic calcifications in the right external and internal iliac arteries, with scattered areas of stenosis.  There are moderate calcified and noncalcified atherosclerotic plaques in the aorta and its major branches.  There is no evidence of a flap within the aorta to suggest a dissection.  The celiac artery and SMA are patent. The IMA is excluded. There are single renal artery bilaterally. They are widely patent without signs of significant stenosis.    The aortoiliac system is patent without significant stenosis. There is no vein thrombosis.   NON VASCULAR: LOWER THORAX: There is diffuse bronchial wall thickening with areas of mucosal plugging and scattered groundglass opacities the right middle and lower lobes, suggestive of aspiration. There is a moderate-sized hiatal hernia.  HEPATOBILIARY: No focal hepatic lesions.  No biliary ductal dilatation. SPLEEN: No splenomegaly. PANCREAS: No focal masses or ductal dilatation.  ADRENALS: No adrenal nodules. KIDNEYS/URETERS: No hydronephrosis, stones, or solid mass lesions. Again seen are unchanged scattered hypodensities throughout the kidneys, too small to characterize. PELVIC ORGANS/BLADDER: There is diffuse bladder wall thickening and pericystic fat stranding.  PERITONEUM / RETROPERITONEUM: No free air or fluid. LYMPH NODES: No lymphadenopathy.  GI TRACT: No distention or wall thickening. The appendix is unremarkable.  BONES AND SOFT TISSUES: There are postoperative changes from left total hip arthroplasty and fixation of the right femur. There are multiple healed fractures in bilateral lower ribs. There are discogenic degenerative changes, most prominently seen at L1-2 disc space. There is a right small fat-containing inguinal hernia.  IMPRESSION: Status post abdominal aorta endograft, stable since 2016.  CT findings suggestive of acute cystitis.  Diffuse bronchial wall thickening with areas of mucosal plugging and scattered groundglass opacities the right middle and lower lobes, suggestive of aspiration.  ATTESTATION: I, Dr. Laura L. Avery, MD as teaching physician, have reviewed the images for this case and if necessary edited the report originally created by Dr. Maria Gabriela Figueiro Longo.   Interpreted by: Laura Louise Avery, MD Maria Gabriela Figueiro Longo, MD  Signed by: Laura Louise Avery, MD 4/23/20  CC Recipients: David A Peak, MD - In Basket (authorizing provider)  Final result","filename":null,"type":"RAW","id":null}]'
                        },
                        {
                            source: "case_data",
                            key: "exam_description",
                            value: "CT ANGIO ABDOMEN/PELVIS WITH AND WITHOUT CONTRAST"
                        },
                        {
                            source: "case_data",
                            key: "result_status",
                            value: "F"
                        },
                        {
                            source: "case_data",
                            key: "exam_code",
                            value: "CT.VA.ABDPELAG@"
                        },
                        {
                            source: "case_data",
                            key: "scheduling_department",
                            value: "null"
                        },
                        {
                            source: "case_data",
                            key: "resource_name",
                            value: "null"
                        },
                        {
                            source: "case_data",
                            key: "billing_provider_number",
                            value: '{"number":"1005151","issuer":"EPIC","type":"EPIC"}'
                        },
                        {
                            source: "case_data",
                            key: "tenant_code",
                            value: "MGH"
                        },
                        {
                            source: "case_data",
                            key: "health_system_code",
                            value: "PHS"
                        },
                        {
                            source: "case_data",
                            key: "date_of_service",
                            value: "2020-04-23"
                        },
                        {
                            source: "process_var_data",
                            key: "previousProcessInstanceStatus",
                            value: "null"
                        },
                        {
                            source: "process_var_data",
                            key: "exam_code_changed",
                            value: "null"
                        }
                    ],
                    decisionOutputs: []
                }
            ]
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "PrePredictionCategorizeProcess",
                    activityId: "PrePredictionTenantDecorationBusinessTask",
                    type: "businessRuleTask",
                    name: "Run tenant decoration",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:25.330-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:25.329-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:25.425-0400[America/New_York]",
                inputs: [
                    {
                        key: "decisionKeys",
                        value: '["pre_prediction_decoration_mgh"]'
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeavePrePredictionTenantDecorationBusinessTask",
                            name: null,
                            destinationId: "EndPrePredictionDecoratorRulesSubprocess",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: [
                {
                    processId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                    executionTime: "2021-03-16T11:26:25.369-0400[America/New_York]",
                    decisionDefinitionDto: {
                        taskId: "PrePredictionTenantDecorationBusinessTask",
                        decisionKey: "pre_prediction_decoration_mgh",
                        decisionName: "Pre-Prediction Decoration MGH",
                        hitPolicy: "COLLECT",
                        camundaVersion: 15,
                        decisionRules: [
                            {
                                ruleId: "DecisionRule_00dfamb",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1jpuk31",
                                        condition: '${cmx:doesStringEqualValueIgnoreCase(caseRun.getResourceName(), "MGH POROR")}'
                                    }
                                ]
                            }
                        ]
                    },
                    decisionInputs: [
                        {
                            source: "case_data",
                            key: "resource_name",
                            value: "null"
                        }
                    ],
                    decisionOutputs: []
                }
            ]
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "PrePredictionRulesSubprocess",
                    type: "callActivity",
                    name: "Run pre-prediction rules",
                    subprocessName: "PrePredictionRulesProcess"
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:25.671-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:25.670-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:26.119-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeavePrePredictionRulesSubprocess",
                            name: null,
                            destinationId: "CheckPrePredictionRoutingExclusiveGateway",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "PrePredictionRulesProcess",
                    activityId: "StartPrePredictionRulesSubprocess",
                    type: "startEvent",
                    name: "Start pre-prediction rules",
                    subprocessName: null
                },
                iteration: 0,
                createdDate: "2021-03-16T11:26:25.731-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:25.728-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:25.728-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveStartPrePredictionRulesSubprocess",
                            name: null,
                            destinationId: "SystemPrePredictionRulesBusinessTask",
                            condition: null
                        },
                        iterations: "0"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "PrePredictionRulesProcess",
                    activityId: "SystemPrePredictionRulesBusinessTask",
                    type: "businessRuleTask",
                    name: "Run system rules",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:25.758-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:25.757-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:26.013-0400[America/New_York]",
                inputs: [
                    {
                        key: "decisionKeys",
                        value: '["pre_prediction_rules"]'
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveSystemPrePredictionRulesBusinessTask",
                            name: null,
                            destinationId: "EndPrePredictionRulesSubprocess",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: [
                {
                    processId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                    executionTime: "2021-03-16T11:26:25.854-0400[America/New_York]",
                    decisionDefinitionDto: {
                        taskId: "SystemPrePredictionRulesBusinessTask",
                        decisionKey: "pre_prediction_rules",
                        decisionName: "Pre-Prediction Rules",
                        hitPolicy: "FIRST",
                        camundaVersion: 15,
                        decisionRules: [
                            {
                                ruleId: "DecisionRule_11mwpme",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_01gfc1b",
                                        condition: '${cmx:hasDecoration("Customer","Original Final Automated",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0k59xdk",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1ghdbdg",
                                        condition: '${cmx:hasDecoration("Manual Case","Subsequent Update of Manual Case",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_107lxgx",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0o7h4lp",
                                        condition: '${cmx:hasDecoration("Customer","Invalid Date of Service",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0p40hix",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0zz86oc",
                                        condition: '${cmx:hasDecoration("Invalid Case","Date of Service Cutover",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1kqb4ut",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0grgk77",
                                        condition: '${cmx:hasDecoration("Invalid Case","Date of Service Invalid for Prediction",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0oyy2na",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0uha36o",
                                        condition: '${cmx:hasDecoration("Invalid Case","Date of Service",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1i10sqd",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0k7t339",
                                        condition: '${cmx:hasDecoration("Customer","Excluded Point of Care",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_09gxjsx",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1kosgei",
                                        condition: '${cmx:hasDecoration("Customer","Excluded Department",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1xf2wag",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0a3g07g",
                                        condition: '${cmx:hasDecoration("Customer","Excluded Provider",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0khoguf",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1wwpcyl",
                                        condition: '${cmx:hasDecoration("Customer","Excluded Exam Code",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1ft6a6b",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1tf62is",
                                        condition: '${cmx:hasDecoration("Customer","Excluded Exam Description",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_073wgds",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0ey96oq",
                                        condition: '${cmx:hasDecoration("Invalid Case","Preliminary",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1tt6beb",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0i4xyx3",
                                        condition: '${cmx:hasDecoration("Customer","Excluded From Billing",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1b576m0",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_04xc8py",
                                        condition: '${cmx:hasDecoration("Invalid Case","Aborted",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_07i6umi",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0hfrlt9",
                                        condition: '${cmx:hasDecoration("Customer","Missing Exam Code",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0cgis5q",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0ehcp68",
                                        condition: '${cmx:hasDecoration("Invalid Case","Missing Data",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0zenbn1",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1fxetkw",
                                        condition: '${cmx:hasDecoration("Customer","Bypass Prediction",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1uc0sos",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0gg5hby",
                                        condition: '${cmx:hasDecoration("Customer","Amendment",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1cpm4mq",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_13pku0g",
                                        condition: '${cmx:hasDecoration("Customer","Addendum",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_16c397l",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1wvj8aw",
                                        condition: '${cmx:hasDecoration("Invalid Case","Correction Before Final",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_1481iqi",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_057tt7y",
                                        condition: '${cmx:hasDecoration("Customer","Unknown Exam Code",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_008m05m",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_154l2ey",
                                        condition: '${cmx:hasDecoration("Customer","Send To Coder",caseRun.getDecoration())}'
                                    }
                                ]
                            }
                        ]
                    },
                    decisionInputs: [
                        {
                            source: "case_data",
                            key: "decoration",
                            value: '{"Invalid Case":["Date of Service","Date of Service Invalid for Prediction"]}'
                        }
                    ],
                    decisionOutputs: [
                        {
                            matchedDecisionRuleId: "DecisionRule_1kqb4ut",
                            mappedKey: "route_to_predict",
                            mappedValue: "false"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1kqb4ut",
                            mappedKey: "route_to_billing",
                            mappedValue: "false"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1kqb4ut",
                            mappedKey: "route_to_coder",
                            mappedValue: "true"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1kqb4ut",
                            mappedKey: "route_to_qa",
                            mappedValue: "false"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1kqb4ut",
                            mappedKey: "termination_indicator",
                            mappedValue: "false"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1kqb4ut",
                            mappedKey: "automation_eligible",
                            mappedValue: "false"
                        },
                        {
                            matchedDecisionRuleId: "DecisionRule_1kqb4ut",
                            mappedKey: "pre_prediction_process_reason",
                            mappedValue: "Invalid Case:Date of Service Invalid for Prediction"
                        }
                    ]
                }
            ]
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "CheckPrePredictionRoutingExclusiveGateway",
                    type: "exclusiveGateway",
                    name: "Route to?",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:26.151-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:26.149-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:26.175-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "RouteToCoderOrTerminate",
                            name: "Route to coder or terminate",
                            destinationId: "CheckRoutingExclusiveGateway",
                            condition: "${((caseRun.getRouteToPredict() == false) && ((caseRun.getRouteToCoder() == true) || (caseRun.getTerminationIndicator() == true)))}"
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "CheckRoutingExclusiveGateway",
                    type: "exclusiveGateway",
                    name: null,
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:26.205-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:26.204-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:26.219-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveCheckRoutingExclusiveGateway",
                            name: null,
                            destinationId: "RoutingSubprocess",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "default_radiology_v1",
                    activityId: "RoutingSubprocess",
                    type: "callActivity",
                    name: "Run routing subprocess",
                    subprocessName: "RouteProcess"
                },
                iteration: 0,
                createdDate: "2021-03-16T11:26:26.250-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:26.249-0400[America/New_York]",
                lastEndTimestamp: null,
                inputs: [],
                outputs: [],
                transitions: []
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "RouteProcess",
                    activityId: "StartRoutingSubprocess",
                    type: "startEvent",
                    name: "Start routing",
                    subprocessName: null
                },
                iteration: 0,
                createdDate: "2021-03-16T11:26:26.348-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:26.330-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:26.330-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveStartRoutingSubprocess",
                            name: "",
                            destinationId: "SelectedRoutesInclusiveGateway",
                            condition: null
                        },
                        iterations: "0"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "RouteProcess",
                    activityId: "SelectedRoutesInclusiveGateway",
                    type: "inclusiveGateway",
                    name: "Selected routes?",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:26.361-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:26.360-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:26.375-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "RouteToDestination",
                            name: "Route to Billling Or Coder",
                            destinationId: "RouteToBillingSubprocess",
                            condition: "${((caseRun.getRouteToBilling() == true) || (caseRun.getRouteToCoder() == true))}"
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "RouteProcess",
                    activityId: "RouteToBillingSubprocess",
                    type: "callActivity",
                    name: "Route to Destination",
                    subprocessName: "SendToBillingProcess"
                },
                iteration: 0,
                createdDate: "2021-03-16T11:26:26.405-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:26.404-0400[America/New_York]",
                lastEndTimestamp: null,
                inputs: [],
                outputs: [],
                transitions: []
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToBillingProcess",
                    activityId: "StartSendToBillingProcess",
                    type: "startEvent",
                    name: "Start send to bill",
                    subprocessName: null
                },
                iteration: 0,
                createdDate: "2021-03-16T11:26:26.503-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:26.501-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:26.501-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveStartBillingEvent",
                            name: null,
                            destinationId: "ChargeAssemblyGroupingRulesTask",
                            condition: null
                        },
                        iterations: "0"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToBillingProcess",
                    activityId: "ChargeAssemblyGroupingRulesTask",
                    type: "businessRuleTask",
                    name: "Run Grouping Rules",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:26.512-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:26.512-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:27.855-0400[America/New_York]",
                inputs: [
                    {
                        key: "decisionKeys",
                        value: '["charge_assembly_grouping_rules_phs"]'
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveChargeAssemblyGroupingRules",
                            name: null,
                            destinationId: "HoldOrReleaseServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: [
                {
                    processId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                    executionTime: "2021-03-16T11:26:26.867-0400[America/New_York]",
                    decisionDefinitionDto: {
                        taskId: "ChargeAssemblyGroupingRulesTask",
                        decisionKey: "charge_assembly_grouping_rules_phs",
                        decisionName: "Charge Assembly Grouping Rules PHS",
                        hitPolicy: "FIRST",
                        camundaVersion: 15,
                        decisionRules: [
                            {
                                ruleId: "DecisionRule_14esd9v",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0qrowbb",
                                        condition: '${cmx:hasDecoration("Automate","Unconditional Automation",caseRun.getDecoration())}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0x0ozdi",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1br29jq",
                                        condition: '${cmx:isInTenantDictionary("IR Wait For Exam Codes",caseRun.getTenantCode(), caseRun.getDateOfService(), caseRun.getExamCode(), true)}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0cjcvsi",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_0juhx8c",
                                        condition: '${cmx:isInTenantPropertyGroup("IR Hold Codes",caseRun.getTenantCode(),caseRun.getDateOfService(),true,cmx:nvp("Exam Code",caseRun.getExamCode()), cmx:nvp("Hold Minutes","*"))}'
                                    }
                                ]
                            },
                            {
                                ruleId: "DecisionRule_0cmwmm8",
                                decisionRuleConditions: [
                                    {
                                        conditionId: "UnaryTests_1pqbci1",
                                        condition: "${true}"
                                    }
                                ]
                            }
                        ]
                    },
                    decisionInputs: [
                        {
                            source: "case_data",
                            key: "decoration",
                            value: '{"Invalid Case":["Date of Service","Date of Service Invalid for Prediction"]}'
                        },
                        {
                            source: "case_data",
                            key: "tenant_code",
                            value: "MGH"
                        },
                        {
                            source: "case_data",
                            key: "date_of_service",
                            value: "2020-04-23"
                        },
                        {
                            source: "case_data",
                            key: "exam_code",
                            value: "CT.VA.ABDPELAG@"
                        }
                    ],
                    decisionOutputs: [
                        {
                            matchedDecisionRuleId: "DecisionRule_0cmwmm8",
                            mappedKey: "action",
                            mappedValue: "case_encounter_work_queue_group"
                        }
                    ]
                }
            ]
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToBillingProcess",
                    activityId: "HoldOrReleaseServiceTask",
                    type: "serviceTask",
                    name: "Hold Or Release",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:27.866-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:27.865-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:27.932-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveHoldOrReleaseServiceTask",
                            name: null,
                            destinationId: "ChargeAssemblyHoldReleaseRulesGateway",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToBillingProcess",
                    activityId: "ChargeAssemblyHoldReleaseRulesGateway",
                    type: "exclusiveGateway",
                    name: null,
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:27.960-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:27.960-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:27.971-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveHoldReleaseGatewayToReleaseCase",
                            name: "Release\nCase",
                            destinationId: "UpdateProcessInstanceStatusToSubmitGroup",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToBillingProcess",
                    activityId: "UpdateProcessInstanceStatusToSubmitGroup",
                    type: "serviceTask",
                    name: 'Update process instance status to "Ready to Submit Group"',
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:28.001-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:28.000-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:26:28.365-0400[America/New_York]",
                inputs: [
                    {
                        key: "status",
                        value: "Ready to Submit Group"
                    }
                ],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveUpdateProcessInstanceStatusToSubmitGroup",
                            name: null,
                            destinationId: "FixedWaitBeforeSubmittingGroup",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToBillingProcess",
                    activityId: "FixedWaitBeforeSubmittingGroup",
                    type: "intermediateTimer",
                    name: "Wait before submitting\n(working around\na race condition)",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:26:28.376-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:26:28.374-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:31:43.473-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveFixedWaitBeforeSubmittingGroup",
                            name: null,
                            destinationId: "SubmitGroupServiceTask",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToBillingProcess",
                    activityId: "SubmitGroupServiceTask",
                    type: "serviceTask",
                    name: "Submit Group",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:31:43.491-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:31:43.490-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:31:43.558-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveSubmitGroupServiceTask",
                            name: null,
                            destinationId: "ReleaseToCoderOrCCIEditGateway",
                            condition: null
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToBillingProcess",
                    activityId: "ReleaseToCoderOrCCIEditGateway",
                    type: "exclusiveGateway",
                    name: null,
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:31:43.571-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:31:43.570-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:31:43.581-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveReleaseToCoderOrCCIEditGatewayToCoder",
                            name: "Release to CAC\nif group is IRHold\nor group has all\nmanual cases",
                            destinationId: "SendToCACMessageThrowEvent",
                            condition: "${caseRun.getReleaseToCoder() == true}"
                        },
                        iterations: "1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToBillingProcess",
                    activityId: "SendToCACMessageThrowEvent",
                    type: "intermediateMessageThrowEvent",
                    name: "post send to\ncoder message",
                    subprocessName: null
                },
                iteration: 0,
                createdDate: "2021-03-16T11:31:43.684-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:31:43.681-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:31:43.681-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveSendToCACMessageThrowEvent",
                            name: null,
                            destinationId: "CallRouteToCoderSubprocess",
                            condition: null
                        },
                        iterations: "0"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToBillingProcess",
                    activityId: "CallRouteToCoderSubprocess",
                    type: "callActivity",
                    name: "Route to coder",
                    subprocessName: "SendToCACProcess"
                },
                iteration: 0,
                createdDate: "2021-03-16T11:31:43.691-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:31:43.690-0400[America/New_York]",
                lastEndTimestamp: null,
                inputs: [],
                outputs: [],
                transitions: []
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToCACProcess",
                    activityId: "StartSendToCACSubprocess",
                    type: "startEvent",
                    name: "Start send to CAC",
                    subprocessName: null
                },
                iteration: 0,
                createdDate: "2021-03-16T11:31:43.787-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:31:43.785-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T11:31:43.785-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveStartSendToCacEvent",
                            name: null,
                            destinationId: "CheckCodingRequiredServiceTask",
                            condition: null
                        },
                        iterations: "0"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToCACProcess",
                    activityId: "CheckCodingRequiredServiceTask",
                    type: "serviceTask",
                    name: "Check coding required",
                    subprocessName: null
                },
                iteration: 1,
                createdDate: "2021-03-16T11:31:43.813-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T11:31:43.812-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T14:13:49.634-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveCheckCodingRequiredServiceTask",
                            name: null,
                            destinationId: "CodedCodingRequiredGateway",
                            condition: null
                        },
                        iterations: "1,1,1,1,1,1"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToCACProcess",
                    activityId: "CodedCodingRequiredGateway",
                    type: "exclusiveGateway",
                    name: "manual coding required?",
                    subprocessName: null
                },
                iteration: 6,
                createdDate: "2021-03-16T11:31:43.961-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T14:13:49.740-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T14:13:49.781-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "CodingRequired",
                            name: "Yes",
                            destinationId: "SkipOruFetchGateway",
                            condition: null
                        },
                        iterations: "1,2,3,4,5,6"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToCACProcess",
                    activityId: "SkipOruFetchGateway",
                    type: "exclusiveGateway",
                    name: null,
                    subprocessName: null
                },
                iteration: 6,
                createdDate: "2021-03-16T11:31:43.982-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T14:13:49.794-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T14:13:49.827-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "MockSendToCAC",
                            name: null,
                            destinationId: "SkipOruFetchEndGateway",
                            condition: "${oruFetchEnabled != null && oruFetchEnabled == false}"
                        },
                        iterations: "1,2,3,4,5,6"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToCACProcess",
                    activityId: "SkipOruFetchEndGateway",
                    type: "exclusiveGateway",
                    name: null,
                    subprocessName: null
                },
                iteration: 6,
                createdDate: "2021-03-16T11:31:44.019-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T14:13:49.849-0400[America/New_York]",
                lastEndTimestamp: "2021-03-16T14:13:49.878-0400[America/New_York]",
                inputs: [],
                outputs: [],
                transitions: [
                    {
                        transitionDefinition: {
                            transitionId: "LeaveReceiveFromCACExclusiveGateway",
                            name: null,
                            destinationId: "UpdateCaseStatusToManualTask",
                            condition: null
                        },
                        iterations: "1,2,3,4,5,6"
                    }
                ]
            },
            decisions: []
        },
        {
            activity: {
                rootProcessInstanceId: "a27bd8a6-866b-11eb-9f4d-cec4d8bfc5e1",
                activityDefinition: {
                    processDefinitionKey: "SendToCACProcess",
                    activityId: "UpdateCaseStatusToManualTask",
                    type: "serviceTask",
                    name: "Update case status to 'Manual'",
                    subprocessName: null
                },
                iteration: 0,
                createdDate: "2021-03-16T11:31:44.058-0400[America/New_York]",
                lastStartTimestamp: "2021-03-16T14:13:49.904-0400[America/New_York]",
                lastEndTimestamp: null,
                inputs: [],
                outputs: [],
                transitions: []
            },
            decisions: []
        }
    ]
};
exports.bpmSteps2 = bpmSteps2;
var bpmSteps2NumberId = {
    1: bpmSteps2["8e8735f8-60a8-11eb-b6f6-9e5278390029"]
};
exports.bpmSteps2NumberId = bpmSteps2NumberId;
//# sourceMappingURL=bpm2.js.map